import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/movies';

export default function LatestUpdates() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50" aria-label="最新更新">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              最新更新
            </h2>
            <p className="text-sm text-foreground-600 mt-1">每日更新，追剧不等待</p>
          </div>
          <div className="flex items-center gap-2">
            {['全部', '电影', '电视剧', '动漫', '综艺'].map((tab, i) => (
              <button
                key={tab}
                className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  i === 0
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {latestUpdates.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[2/3] mb-3">
                <img
                  src={movie.image}
                  alt={`屁屁影院 - ${movie.title}`}
                  title={`屁屁影院${movie.title}在线观看`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-500 text-background-50 text-xs font-semibold">
                    {movie.episode}
                  </span>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold">
                    {movie.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                {movie.tags.map((tag) => (
                  <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full">
                    {tag}
                  </span>
                ))}
                <span className="text-xs text-foreground-400 ml-auto">{movie.year}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}